/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropentrystatewinnerpending4Inputs */

const en_dropentrystatewinnerpending4 = /** @type {(inputs: Dropentrystatewinnerpending4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Winner - pending claim`)
};

const de_dropentrystatewinnerpending4 = /** @type {(inputs: Dropentrystatewinnerpending4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewonnen – Einlösung offen`)
};

/**
* | output |
* | --- |
* | "Winner - pending claim" |
*
* @param {Dropentrystatewinnerpending4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropentrystatewinnerpending4 = /** @type {((inputs?: Dropentrystatewinnerpending4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropentrystatewinnerpending4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropentrystatewinnerpending4(inputs)
	return de_dropentrystatewinnerpending4(inputs)
});
export { dropentrystatewinnerpending4 as "dropEntryStateWinnerPending" }